import React, { useState, useRef } from 'react';
import { styled } from 'linaria/react';
import SectionWrapper from '../../../Layout/SectionWrapper';
import { theme } from '../../../Theme';
import PlayButton from '../../../ui/PlayButton';

const VideoPlayerWrapper = styled(SectionWrapper)`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
`;

const ContentWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 80px 32px;
  gap: 8px;
  flex-wrap: wrap;
`;

const VideoWrapper = styled('div')`
  position: relative;
  width: 100%;
  height: auto;
`;

const TextWrapper = styled('div')`
  color: ${theme.colors.black};
  text-align: left;
  font-size: 14px;
  max-width: 342px;
`;

const PlayButtonWrapper = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 2;
  color: white;
  background: transparent;
  font-size: 6.25rem;
  @media (max-width: 768px) {
    font-size: 3.125rem;
  }

  @media (max-width: 480px) {
    font-size: 1.875rem;
  }

  transition: font-size 0.3s ease;
`;

const BackgroundImage = styled('div')`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  background-image: ${({ background }) => `url(${background})`};
  background-size: cover;
  background-position: center;
`;

const LabelWrapper = styled('div')`
  font-family: 'Avenir Next', sans-serif;
  font-weight: 600;
  font-size: inherit;
  color: white;
  margin-right: 10px;
  transition: font-size 0.3s ease;
`;

const VideoElement = styled('video')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const VideoPlayer = ({ background_image, text, button_label, video }) => {
  const [showVideo, setShowVideo] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = () => {
    setShowVideo(true);
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoClick = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <VideoPlayerWrapper>
      <ContentWrapper>
        <TextWrapper>{text}</TextWrapper>
        <VideoWrapper>
          {!showVideo ? (
            <BackgroundImage background={background_image?.filename}>
              <PlayButtonWrapper onClick={handlePlay}>
                {button_label && <LabelWrapper>{button_label}</LabelWrapper>}
                <PlayButton />
              </PlayButtonWrapper>
            </BackgroundImage>
          ) : (
            <VideoElement
              ref={videoRef}
              src={video?.filename}
              controls
              autoPlay
              muted={false}
              loop={true}
              playsInline
              onClick={handleVideoClick}
            >
              <source src={video?.filename} type="video/mp4" />
            </VideoElement>
          )}
        </VideoWrapper>
      </ContentWrapper>
    </VideoPlayerWrapper>
  );
};

export default VideoPlayer;
